// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"26":"bf27bbf24093b319","71":"39d64caaa2afa456","275":"8f8ec9802a28ebf6","533":"26a46a3c63b2b02e","941":"d4ef038b98e5d6f7"}[chunkId] + ".js";
};